/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading dependencies
 * -----------------------------------------------------------------------------------------------------------
 */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/vi'
import * as filters from './filters'
import * as mixins from './mixins'
import 'element-ui/lib/theme-chalk/index.css'
import 'semantic-ui-button/button.min.css'
import 'semantic-ui-label/label.min.css'
// global components
import GsTable from 'components/app/gsTable/GsTable'
import gsTableHelper from 'components/app/gsTable/mixins'
import GsHeader from 'components/app/GsHeader'
// configs axios
import './api/config'

sync(store, router)
// element-ui
Vue.use(ElementUI, { locale })

// global components
Vue.component('gs-table', GsTable)
Vue.mixin(gsTableHelper)
Vue.component('gs-header', GsHeader)

// custom filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// common mixins
Object.keys(mixins).forEach(key => {
  Vue.mixin(mixins[key])
})
/* eslint-disable no-new */

new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js